import { todayBusinessCalendarDate } from './dateTime';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Comp Off request and approval are allowed on or before the work date.
 * After that calendar day has ended, backdated requests are rejected.
 * `today` is the current business calendar date (not a hardcoded value).
 */
export function isCompensatoryWorkDateOpen(
  workDate: string,
  today: string = todayBusinessCalendarDate(),
): boolean {
  return DATE_ONLY.test(workDate) && DATE_ONLY.test(today) && workDate >= today;
}

export const COMP_OFF_PAST_WORK_DATE_MESSAGE =
  'Comp Off can be submitted and approved only on or before the work date. Backdated requests are not allowed.';
